import { Box, Link, Flex } from "@radix-ui/themes";
import { CaretRightIcon } from "@radix-ui/react-icons";

import { H2 } from "./Heading";

const TableOfContents: React.FC<{
  contentItems: { title: string; id: string }[];
  primary?: boolean;
  secondary?: boolean;
}> = ({ contentItems, primary, secondary }) => {
  return (
    <Box>
      {primary && <H2 isTableOfContents>Table of Contents</H2>}
      <ul style={{ listStyle: "none", marginTop: 0, padding: 0 }}>
        {contentItems.map((item, index) => {
          return (
            <li key={index}>
              <Link
                href={`#${item.id}`}
                underline="always"
                highContrast={secondary}
              >
                <Flex align="center" gap="2">
                  <CaretRightIcon />
                  {item.title}
                </Flex>
              </Link>
            </li>
          );
        })}
      </ul>
    </Box>
  );
};

export default TableOfContents;
